var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { ThemeConsumer } from "styled-components";
import { appendPx, calcHeightMinusPadding, calcWidthMinusPadding, scalePadding } from "../theme/DefaultTheme";
import { styled } from "../theme/ThemeHelpers";
import { ButtonContainer, calcScaleFactor, ContentContainer, getButtonColor, getButtonHoverColor, getButtonSizes, IconContainer, InnerContainer, getButtonDefinition, getButtonColumnsAndGridDefintion } from "./Button";
import LottieIcon from "./LottieIcon";
var Container = styled(ButtonContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    stroke: ", ";\n    fill: ", ";\n    &:hover {\n        stroke: ", ";\n        fill: ", ";\n    }\n"], ["\n    stroke: ", ";\n    fill: ", ";\n    &:hover {\n        stroke: ", ";\n        fill: ", ";\n    }\n"])), function (props) { return getButtonColor(props, props.kind); }, function (props) { return getButtonColor(props, props.kind); }, function (props) { return getButtonHoverColor(props, props.kind); }, function (props) { return getButtonHoverColor(props, props.kind); });
var IconSizeContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", ";    \n    width: ", ";\n    /* padding-top:10%; */\n    text-align: center;\n    margin: auto;\n"], ["\n    height: ", ";    \n    width: ", ";\n    /* padding-top:10%; */\n    text-align: center;\n    margin: auto;\n"])), function (props) { return appendPx(props.height); }, function (props) { return appendPx(props.width); });
var LottieButton = /** @class */ (function (_super) {
    __extends(LottieButton, _super);
    function LottieButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.direction = 1;
        _this.state = { run: true };
        _this.run = function (run) { return function () {
            if (_this.state.pause)
                _this.state.pause(!run);
        }; };
        _this.handleClick = function (event) {
            var _a;
            if (_this.state.play)
                _this.state.play(_this.direction);
            _this.direction = ((_a = _this.props.lottie) === null || _a === void 0 ? void 0 : _a.behaviour) === "PlayOnClickToggleDirection" ? -_this.direction : _this.direction;
            if (_this.props.onClick)
                _this.props.onClick(event);
        };
        _this.getMethods = function (play, stop, pause) {
            _this.setState({ play: play, stop: stop, pause: pause });
        };
        return _this;
    }
    LottieButton.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j = this.props, selected = _j.selected, ingroup = _j.ingroup;
        if (ingroup && !selected && this.direction === -1 && this.state.play && ((_a = this.props.lottie) === null || _a === void 0 ? void 0 : _a.behaviour) === "PlayOnClickToggleDirection") {
            this.state.play(this.direction);
            this.direction = 1;
        }
        if (!selected && this.direction === -1 && this.state.play && ((_b = this.props.lottie) === null || _b === void 0 ? void 0 : _b.behaviour) === "PlayOnClickToggleDirection") {
            this.state.play(this.direction);
            this.direction = 1;
        }
        if (selected && this.direction === 1 && this.state.play && ((_c = this.props.lottie) === null || _c === void 0 ? void 0 : _c.behaviour) === "PlayOnClickToggleDirection") {
            this.state.play(this.direction);
            this.direction = -1;
        }
        var content = this.props.content !== undefined;
        var lottie = this.props.lottie !== undefined;
        var poh = ((_d = this.props.lottie) === null || _d === void 0 ? void 0 : _d.behaviour) === "PauseOnHover";
        var porl = ((_e = this.props.lottie) === null || _e === void 0 ? void 0 : _e.behaviour) === "PauseOnHover" || ((_f = this.props.lottie) === null || _f === void 0 ? void 0 : _f.behaviour) === "Loop";
        var cl = ((_g = this.props.lottie) === null || _g === void 0 ? void 0 : _g.behaviour) === "PlayOnClick" || ((_h = this.props.lottie) === null || _h === void 0 ? void 0 : _h.behaviour) === "PlayOnClickToggleDirection";
        return (React.createElement(ThemeConsumer, null, function (theme) {
            var _a, _b, _c, _d, _e, _f;
            var bdef = getButtonDefinition({ theme: theme }, _this.props.kind);
            var sizes = getButtonSizes(theme, _this.props.size);
            var f = calcScaleFactor(theme, sizes);
            // const bh = calcHeightMinusPadding(sizes.buttonHeight, this.props.bordered ? sizes.paddingBordered : sizes.padding);
            var bh = calcHeightMinusPadding(sizes.buttonHeight, sizes.padding);
            var height = calcHeightMinusPadding(bh, ((_a = _this.props.lottie) === null || _a === void 0 ? void 0 : _a.padding) ? scalePadding(_this.props.lottie.padding, f) : f * 5);
            var width = calcWidthMinusPadding(bh, ((_b = _this.props.lottie) === null || _b === void 0 ? void 0 : _b.padding) ? scalePadding(_this.props.lottie.padding, f) : f * 5);
            var defs = getButtonColumnsAndGridDefintion(theme, bdef, content, true, bh);
            return (React.createElement(Container, __assign({}, _this.props, { sizes: sizes, onMouseEnter: poh ? _this.run(false) : undefined, onMouseLeave: poh ? _this.run(true) : undefined, onClick: cl ? _this.handleClick : _this.props.onClick, style: { cursor: "pointer", float: (_c = _this.props.floated) !== null && _c !== void 0 ? _c : undefined, textAlign: defs.textAlign } }),
                React.createElement(InnerContainer, { height: bh, fontSize: sizes.fontSize, gridColumnDef: defs.gridColumnDefinition },
                    _this.props.lottie &&
                        React.createElement(IconContainer, { padding: (_d = _this.props.lottie.padding) !== null && _d !== void 0 ? _d : sizes.padding, col: defs.iconColumn },
                            React.createElement(IconSizeContainer, { height: height, width: width },
                                React.createElement(LottieIcon, __assign({}, _this.props.lottie, { loop: porl, autoplay: porl, getMethods: _this.getMethods, height: height, width: width, speed: (_e = _this.props.speed) !== null && _e !== void 0 ? _e : undefined })))),
                    content &&
                        React.createElement(ContentContainer, { padding: (_f = _this.props.contentPadding) !== null && _f !== void 0 ? _f : (_this.props.lottie ? sizes.contentPaddingWithIcon : sizes.contentPaddingWithoutIcon), col: defs.contentColumn }, _this.props.content))));
        }));
    };
    return LottieButton;
}(React.PureComponent));
export default LottieButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=LottieButton.js.map